module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner _clearboth hide-sm mt-0"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "banner__list"
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a1722f5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a1722f5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 753
// module chunks = 1